var host = "https://api-doc.smicee.com";


const { h } = require("vue");

module.exports = {
    V1API: {
        'getAccessToken': host + '/api/authentication/token',
        'refreshAccessToken': host + '/api/authentication/token/refresh',
        'verifyLogin': host + '/api/authentication/token/verify',

        // Project Doc
        // Upazila
        'upazila_list': host + '/api/location/upozila',
        'create_upazila': host + '/api/location/upozila/create',
        'update_upazila': host + '/api/location/upozila/edit/',
        'upazila_delete': host + '/api/location/upozila/delete/',

        // Union
        'union_list': host + '/api/location/union',
        'union_list_by_upazila': host + '/api/location/union/by-upozila/',
        'create_union': host + '/api/location/union/create',
        'update_union': host + '/api/location/union/edit/',
        'union_delete': host + '/api/location/union/delete/',

        // Shelter
        'shelter_list': host + '/api/location/shelter',
        'create_shelter': host + '/api/location/shelter/create',
        'update_shelter': host + '/api/location/shelter/edit/',
        'shelter_delete': host + '/api/location/shelter/delete/',

        // Volunteer
        'volunteer_list': host + '/api/volunteer/accounts/list',
        'create_volunteer': host + '/api/volunteer/accounts/create',
        'update_volunteer': host + '/api/volunteer/accounts/edit/full/',
        'volunteer_delete': host + '/api/access-control/user-accounts/delete/',

        //Portfolio
        // Blog
        'blog_list':host+'/api/blog/list',
        'create_blog':host+'/api/blog/create',
        'get_blog_details':host+'/api/blog/getdetail/slug',
        'update_blog':host+'/api/blog/update/',
        'blog_delete':host+'/api/blog/delete/',

        // Media Appearances
        'media_list':host+'/api/media_appearance/list',
        'create_media':host+'/api/media_appearance/create',
        'get_media_details':host+'/api/media_appearance/detail/slug',
        'update_media':host+'/api/media_appearance/update/',
        'media_delete':host+'/api/media_appearance/delete/',

        //Collaboration
        'collaboration_list':host+'/api/collaboration/list',
        'create_collaboration':host+'/api/collaboration/create',
        'get_collaboration_details':host+'/api/collaboration/getdetail/',
        'update_collaboration':host+'/api/collaboration/update/',
        'collaboration_delete':host+'/api/collaboration/delete/',

        // Gallery
        'gallery_list':host+'/api/gallery/list',
        'create_gallery':host+'/api/gallery/create',
        'get_gallery_details':host+'/api/gallery/detail/',
        'update_gallery':host+'/api/gallery/update/',
        'gallery_delete':host+'/api/gallery/delete/',

        //Publications
        'publication_list':host+'/api/publication/',
        'create_publication':host+'/api/publication/create',
        'get_publication_details':host+'/api/publication/detail/',
        'update_publication':host+'/api/publication/update/',
        'publication_delete':host+'/api/publication/delete/',
        'publication_category':host+'/api/publication/category/list',

        //Contact
        'contact_list':host+'/api/contact/message/list',
        'contact_delete':host+'/api/contact/delete/',

        // Recents
        'recent_list':host+'/api/recent/list',
        'create_recent':host+'/api/recent/create',
        'get_recent_details':host+'/api/recent/getdetail/',
        'update_recent':host+'/api/recent/update/',
        'recent_delete':host+'/api/recent/delete/',



    }
};
